import { render, staticRenderFns } from "./ContactCustomerCare.vue?vue&type=template&id=d37e101a&scoped=true&"
import script from "./ContactCustomerCare.vue?vue&type=script&lang=js&"
export * from "./ContactCustomerCare.vue?vue&type=script&lang=js&"
import style0 from "./ContactCustomerCare.vue?vue&type=style&index=0&id=d37e101a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37e101a",
  null
  
)

export default component.exports